var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifyBeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75889 6.76896L9.13238 4.89865L9.13636 4.89747L16.4254 2.75849C16.6106 2.70416 16.8057 2.69395 16.9955 2.72866C17.1853 2.76338 17.3644 2.84207 17.5187 2.95851C17.673 3.07495 17.7982 3.22593 17.8845 3.3995C17.9707 3.57307 18.0156 3.76447 18.0156 3.95852V14.7918C18.0154 15.1227 17.8849 15.4401 17.6528 15.6745C17.4206 15.909 17.1056 16.0414 16.7767 16.0428C16.6578 16.0426 16.5395 16.0255 16.4253 15.9918L9.93955 14.0886V15.0002C9.93918 15.3316 9.80816 15.6493 9.57525 15.8836C9.34233 16.118 9.02654 16.2498 8.69715 16.2502H6.21235C5.88296 16.2498 5.56716 16.118 5.33425 15.8836C5.10134 15.6493 4.97032 15.3316 4.96994 15.0002V12.6302L2.75896 11.9814C2.50142 11.9048 2.2753 11.7466 2.11415 11.5305C1.95301 11.3143 1.86542 11.0516 1.86439 10.7814V7.96891C1.86541 7.69872 1.95298 7.43605 2.11412 7.21989C2.27525 7.00373 2.50136 6.8456 2.75889 6.76896ZM6.21235 15.0002H8.69715V13.724L6.21235 12.9949V15.0002ZM3.10679 10.7814L5.77435 11.5642L5.77655 11.5648L8.69715 12.4219V6.3284L3.10679 7.96891V10.7814Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyBeo);
export default __webpack_public_path__ + "static/media/notify_beo.53546c288acd94735346a5464d2b44bb.svg";
export { ForwardRef as ReactComponent };